import { useSelector } from "react-redux";

const usePoints = () => {
 
  const userState = useSelector((state) => state.userState);

  const currentPoints = userState.currentPeriod.points ?? 0
  const nextPoints = userState.nextPeriod.points ?? 0

 
  return [currentPoints, nextPoints] ;
};

export default usePoints;
